import { render, staticRenderFns } from "./RuleInput.vue?vue&type=template&id=1b48e38e&"
import script from "./RuleInput.vue?vue&type=script&lang=ts&"
export * from "./RuleInput.vue?vue&type=script&lang=ts&"
import style0 from "./RuleInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports